/**
 * This file is automatically generated.
 **/
import type { EntityTypeMeta } from '../EntityTypeMeta'
import { EntityTypeId, HasEntityTypeId } from './EntityTypeId.enum'
import type { Entity } from './index'
import type { EntityGraphNode } from '../engine/EntityGraphNode/EntityGraphNode.type'
import { immutableEmptyArray } from '../../lib'

import {
  APCEntityTypeMeta,
  APCEntitySchema,
  APCEntity,
} from './EntityType/APC'
import {
  BuildingEntityTypeMeta,
  BuildingEntitySchema,
  BuildingEntity,
} from './EntityType/Building'
import {
  DeadwoodEntityTypeMeta,
  DeadwoodEntitySchema,
  DeadwoodEntity,
} from './EntityType/Deadwood'
import {
  DesertEntityTypeMeta,
  DesertEntitySchema,
  DesertEntity,
} from './EntityType/Desert'
import {
  FactoryEntityTypeMeta,
  FactoryEntitySchema,
  FactoryEntity,
} from './EntityType/Factory'
import {
  ForestEntityTypeMeta,
  ForestEntitySchema,
  ForestEntity,
} from './EntityType/Forest'
import {
  HQEntityTypeMeta,
  HQEntitySchema,
  HQEntity,
} from './EntityType/HQ'
import {
  InfantryEntityTypeMeta,
  InfantryEntitySchema,
  InfantryEntity,
} from './EntityType/Infantry'
import {
  JungleEntityTypeMeta,
  JungleEntitySchema,
  JungleEntity,
} from './EntityType/Jungle'
import {
  LakeEntityTypeMeta,
  LakeEntitySchema,
  LakeEntity,
} from './EntityType/Lake'
import {
  LightReconEntityTypeMeta,
  LightReconEntitySchema,
  LightReconEntity,
} from './EntityType/LightRecon'
import {
  LightTankEntityTypeMeta,
  LightTankEntitySchema,
  LightTankEntity,
} from './EntityType/LightTank'
import {
  MarshEntityTypeMeta,
  MarshEntitySchema,
  MarshEntity,
} from './EntityType/Marsh'
import {
  MediumArtillaryEntityTypeMeta,
  MediumArtillaryEntitySchema,
  MediumArtillaryEntity,
} from './EntityType/MediumArtillary'
import {
  MediumCopterEntityTypeMeta,
  MediumCopterEntitySchema,
  MediumCopterEntity,
} from './EntityType/MediumCopter'
import {
  MediumGunAntiAirEntityTypeMeta,
  MediumGunAntiAirEntitySchema,
  MediumGunAntiAirEntity,
} from './EntityType/MediumGunAntiAir'
import {
  MediumMissileAntiAirEntityTypeMeta,
  MediumMissileAntiAirEntitySchema,
  MediumMissileAntiAirEntity,
} from './EntityType/MediumMissileAntiAir'
import {
  MediumRocketsEntityTypeMeta,
  MediumRocketsEntitySchema,
  MediumRocketsEntity,
} from './EntityType/MediumRockets'
import {
  MediumTankEntityTypeMeta,
  MediumTankEntitySchema,
  MediumTankEntity,
} from './EntityType/MediumTank'
import {
  MountainEntityTypeMeta,
  MountainEntitySchema,
  MountainEntity,
} from './EntityType/Mountain'
import {
  PlainEntityTypeMeta,
  PlainEntitySchema,
  PlainEntity,
} from './EntityType/Plain'
import {
  RiverEntityTypeMeta,
  RiverEntitySchema,
  RiverEntity,
} from './EntityType/River'
import {
  RoadEntityTypeMeta,
  RoadEntitySchema,
  RoadEntity,
} from './EntityType/Road'
import {
  SeaEntityTypeMeta,
  SeaEntitySchema,
  SeaEntity,
} from './EntityType/Sea'
import {
  ShoalEntityTypeMeta,
  ShoalEntitySchema,
  ShoalEntity,
} from './EntityType/Shoal'
import {
  SnowEntityTypeMeta,
  SnowEntitySchema,
  SnowEntity,
} from './EntityType/Snow'
import {
  SwampEntityTypeMeta,
  SwampEntitySchema,
  SwampEntity,
} from './EntityType/Swamp'
import {
  TransportCopterEntityTypeMeta,
  TransportCopterEntitySchema,
  TransportCopterEntity,
} from './EntityType/TransportCopter'

const entityTypeMetaList : Array<EntityTypeMeta> = [
  APCEntityTypeMeta,
  BuildingEntityTypeMeta,
  DeadwoodEntityTypeMeta,
  DesertEntityTypeMeta,
  FactoryEntityTypeMeta,
  ForestEntityTypeMeta,
  HQEntityTypeMeta,
  InfantryEntityTypeMeta,
  JungleEntityTypeMeta,
  LakeEntityTypeMeta,
  LightReconEntityTypeMeta,
  LightTankEntityTypeMeta,
  MarshEntityTypeMeta,
  MediumArtillaryEntityTypeMeta,
  MediumCopterEntityTypeMeta,
  MediumGunAntiAirEntityTypeMeta,
  MediumMissileAntiAirEntityTypeMeta,
  MediumRocketsEntityTypeMeta,
  MediumTankEntityTypeMeta,
  MountainEntityTypeMeta,
  PlainEntityTypeMeta,
  RiverEntityTypeMeta,
  RoadEntityTypeMeta,
  SeaEntityTypeMeta,
  ShoalEntityTypeMeta,
  SnowEntityTypeMeta,
  SwampEntityTypeMeta,
  TransportCopterEntityTypeMeta,
]

export const entitySchemaList = [
  APCEntitySchema,
  BuildingEntitySchema,
  DeadwoodEntitySchema,
  DesertEntitySchema,
  FactoryEntitySchema,
  ForestEntitySchema,
  HQEntitySchema,
  InfantryEntitySchema,
  JungleEntitySchema,
  LakeEntitySchema,
  LightReconEntitySchema,
  LightTankEntitySchema,
  MarshEntitySchema,
  MediumArtillaryEntitySchema,
  MediumCopterEntitySchema,
  MediumGunAntiAirEntitySchema,
  MediumMissileAntiAirEntitySchema,
  MediumRocketsEntitySchema,
  MediumTankEntitySchema,
  MountainEntitySchema,
  PlainEntitySchema,
  RiverEntitySchema,
  RoadEntitySchema,
  SeaEntitySchema,
  ShoalEntitySchema,
  SnowEntitySchema,
  SwampEntitySchema,
  TransportCopterEntitySchema,
]

export type EntityTypeIdToEntityMap = {
  [EntityTypeId.APC]: APCEntity
  [EntityTypeId.Building]: BuildingEntity
  [EntityTypeId.Deadwood]: DeadwoodEntity
  [EntityTypeId.Desert]: DesertEntity
  [EntityTypeId.Factory]: FactoryEntity
  [EntityTypeId.Forest]: ForestEntity
  [EntityTypeId.HQ]: HQEntity
  [EntityTypeId.Infantry]: InfantryEntity
  [EntityTypeId.Jungle]: JungleEntity
  [EntityTypeId.Lake]: LakeEntity
  [EntityTypeId.LightRecon]: LightReconEntity
  [EntityTypeId.LightTank]: LightTankEntity
  [EntityTypeId.Marsh]: MarshEntity
  [EntityTypeId.MediumArtillary]: MediumArtillaryEntity
  [EntityTypeId.MediumCopter]: MediumCopterEntity
  [EntityTypeId.MediumGunAntiAir]: MediumGunAntiAirEntity
  [EntityTypeId.MediumMissileAntiAir]: MediumMissileAntiAirEntity
  [EntityTypeId.MediumRockets]: MediumRocketsEntity
  [EntityTypeId.MediumTank]: MediumTankEntity
  [EntityTypeId.Mountain]: MountainEntity
  [EntityTypeId.Plain]: PlainEntity
  [EntityTypeId.River]: RiverEntity
  [EntityTypeId.Road]: RoadEntity
  [EntityTypeId.Sea]: SeaEntity
  [EntityTypeId.Shoal]: ShoalEntity
  [EntityTypeId.Snow]: SnowEntity
  [EntityTypeId.Swamp]: SwampEntity
  [EntityTypeId.TransportCopter]: TransportCopterEntity
}

export type EntitySchemaUnion = (typeof entitySchemaList)[number]


export type EntityUnion = APCEntity | BuildingEntity | DeadwoodEntity | DesertEntity | FactoryEntity | ForestEntity | HQEntity | InfantryEntity | JungleEntity | LakeEntity | LightReconEntity | LightTankEntity | MarshEntity | MediumArtillaryEntity | MediumCopterEntity | MediumGunAntiAirEntity | MediumMissileAntiAirEntity | MediumRocketsEntity | MediumTankEntity | MountainEntity | PlainEntity | RiverEntity | RoadEntity | SeaEntity | ShoalEntity | SnowEntity | SwampEntity | TransportCopterEntity




export function isEntityAPC<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<APCEntity>

export function isEntityAPC(
  entity: Entity
): entity is APCEntity

export function isEntityAPC<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.APC} {
  return entity.etype_id === EntityTypeId.APC
}



export function isEntityBuilding<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<BuildingEntity>

export function isEntityBuilding(
  entity: Entity
): entity is BuildingEntity

export function isEntityBuilding<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.Building} {
  return entity.etype_id === EntityTypeId.Building
}



export function isEntityDeadwood<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<DeadwoodEntity>

export function isEntityDeadwood(
  entity: Entity
): entity is DeadwoodEntity

export function isEntityDeadwood<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.Deadwood} {
  return entity.etype_id === EntityTypeId.Deadwood
}



export function isEntityDesert<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<DesertEntity>

export function isEntityDesert(
  entity: Entity
): entity is DesertEntity

export function isEntityDesert<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.Desert} {
  return entity.etype_id === EntityTypeId.Desert
}



export function isEntityFactory<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<FactoryEntity>

export function isEntityFactory(
  entity: Entity
): entity is FactoryEntity

export function isEntityFactory<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.Factory} {
  return entity.etype_id === EntityTypeId.Factory
}



export function isEntityForest<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<ForestEntity>

export function isEntityForest(
  entity: Entity
): entity is ForestEntity

export function isEntityForest<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.Forest} {
  return entity.etype_id === EntityTypeId.Forest
}



export function isEntityHQ<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<HQEntity>

export function isEntityHQ(
  entity: Entity
): entity is HQEntity

export function isEntityHQ<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.HQ} {
  return entity.etype_id === EntityTypeId.HQ
}



export function isEntityInfantry<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<InfantryEntity>

export function isEntityInfantry(
  entity: Entity
): entity is InfantryEntity

export function isEntityInfantry<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.Infantry} {
  return entity.etype_id === EntityTypeId.Infantry
}



export function isEntityJungle<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<JungleEntity>

export function isEntityJungle(
  entity: Entity
): entity is JungleEntity

export function isEntityJungle<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.Jungle} {
  return entity.etype_id === EntityTypeId.Jungle
}



export function isEntityLake<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<LakeEntity>

export function isEntityLake(
  entity: Entity
): entity is LakeEntity

export function isEntityLake<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.Lake} {
  return entity.etype_id === EntityTypeId.Lake
}



export function isEntityLightRecon<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<LightReconEntity>

export function isEntityLightRecon(
  entity: Entity
): entity is LightReconEntity

export function isEntityLightRecon<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.LightRecon} {
  return entity.etype_id === EntityTypeId.LightRecon
}



export function isEntityLightTank<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<LightTankEntity>

export function isEntityLightTank(
  entity: Entity
): entity is LightTankEntity

export function isEntityLightTank<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.LightTank} {
  return entity.etype_id === EntityTypeId.LightTank
}



export function isEntityMarsh<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<MarshEntity>

export function isEntityMarsh(
  entity: Entity
): entity is MarshEntity

export function isEntityMarsh<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.Marsh} {
  return entity.etype_id === EntityTypeId.Marsh
}



export function isEntityMediumArtillary<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<MediumArtillaryEntity>

export function isEntityMediumArtillary(
  entity: Entity
): entity is MediumArtillaryEntity

export function isEntityMediumArtillary<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.MediumArtillary} {
  return entity.etype_id === EntityTypeId.MediumArtillary
}



export function isEntityMediumCopter<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<MediumCopterEntity>

export function isEntityMediumCopter(
  entity: Entity
): entity is MediumCopterEntity

export function isEntityMediumCopter<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.MediumCopter} {
  return entity.etype_id === EntityTypeId.MediumCopter
}



export function isEntityMediumGunAntiAir<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<MediumGunAntiAirEntity>

export function isEntityMediumGunAntiAir(
  entity: Entity
): entity is MediumGunAntiAirEntity

export function isEntityMediumGunAntiAir<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.MediumGunAntiAir} {
  return entity.etype_id === EntityTypeId.MediumGunAntiAir
}



export function isEntityMediumMissileAntiAir<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<MediumMissileAntiAirEntity>

export function isEntityMediumMissileAntiAir(
  entity: Entity
): entity is MediumMissileAntiAirEntity

export function isEntityMediumMissileAntiAir<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.MediumMissileAntiAir} {
  return entity.etype_id === EntityTypeId.MediumMissileAntiAir
}



export function isEntityMediumRockets<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<MediumRocketsEntity>

export function isEntityMediumRockets(
  entity: Entity
): entity is MediumRocketsEntity

export function isEntityMediumRockets<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.MediumRockets} {
  return entity.etype_id === EntityTypeId.MediumRockets
}



export function isEntityMediumTank<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<MediumTankEntity>

export function isEntityMediumTank(
  entity: Entity
): entity is MediumTankEntity

export function isEntityMediumTank<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.MediumTank} {
  return entity.etype_id === EntityTypeId.MediumTank
}



export function isEntityMountain<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<MountainEntity>

export function isEntityMountain(
  entity: Entity
): entity is MountainEntity

export function isEntityMountain<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.Mountain} {
  return entity.etype_id === EntityTypeId.Mountain
}



export function isEntityPlain<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<PlainEntity>

export function isEntityPlain(
  entity: Entity
): entity is PlainEntity

export function isEntityPlain<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.Plain} {
  return entity.etype_id === EntityTypeId.Plain
}



export function isEntityRiver<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<RiverEntity>

export function isEntityRiver(
  entity: Entity
): entity is RiverEntity

export function isEntityRiver<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.River} {
  return entity.etype_id === EntityTypeId.River
}



export function isEntityRoad<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<RoadEntity>

export function isEntityRoad(
  entity: Entity
): entity is RoadEntity

export function isEntityRoad<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.Road} {
  return entity.etype_id === EntityTypeId.Road
}



export function isEntitySea<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<SeaEntity>

export function isEntitySea(
  entity: Entity
): entity is SeaEntity

export function isEntitySea<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.Sea} {
  return entity.etype_id === EntityTypeId.Sea
}



export function isEntityShoal<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<ShoalEntity>

export function isEntityShoal(
  entity: Entity
): entity is ShoalEntity

export function isEntityShoal<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.Shoal} {
  return entity.etype_id === EntityTypeId.Shoal
}



export function isEntitySnow<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<SnowEntity>

export function isEntitySnow(
  entity: Entity
): entity is SnowEntity

export function isEntitySnow<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.Snow} {
  return entity.etype_id === EntityTypeId.Snow
}



export function isEntitySwamp<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<SwampEntity>

export function isEntitySwamp(
  entity: Entity
): entity is SwampEntity

export function isEntitySwamp<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.Swamp} {
  return entity.etype_id === EntityTypeId.Swamp
}



export function isEntityTransportCopter<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<TransportCopterEntity>

export function isEntityTransportCopter(
  entity: Entity
): entity is TransportCopterEntity

export function isEntityTransportCopter<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: EntityTypeId.TransportCopter} {
  return entity.etype_id === EntityTypeId.TransportCopter
}


export function getAPCEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<APCEntity>> {
  const list = map.get(EntityTypeId.APC) || immutableEmptyArray
  return list as Array<EntityGraphNode<APCEntity>>
}

export function getBuildingEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<BuildingEntity>> {
  const list = map.get(EntityTypeId.Building) || immutableEmptyArray
  return list as Array<EntityGraphNode<BuildingEntity>>
}

export function getDeadwoodEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<DeadwoodEntity>> {
  const list = map.get(EntityTypeId.Deadwood) || immutableEmptyArray
  return list as Array<EntityGraphNode<DeadwoodEntity>>
}

export function getDesertEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<DesertEntity>> {
  const list = map.get(EntityTypeId.Desert) || immutableEmptyArray
  return list as Array<EntityGraphNode<DesertEntity>>
}

export function getFactoryEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<FactoryEntity>> {
  const list = map.get(EntityTypeId.Factory) || immutableEmptyArray
  return list as Array<EntityGraphNode<FactoryEntity>>
}

export function getForestEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<ForestEntity>> {
  const list = map.get(EntityTypeId.Forest) || immutableEmptyArray
  return list as Array<EntityGraphNode<ForestEntity>>
}

export function getHQEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<HQEntity>> {
  const list = map.get(EntityTypeId.HQ) || immutableEmptyArray
  return list as Array<EntityGraphNode<HQEntity>>
}

export function getInfantryEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<InfantryEntity>> {
  const list = map.get(EntityTypeId.Infantry) || immutableEmptyArray
  return list as Array<EntityGraphNode<InfantryEntity>>
}

export function getJungleEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<JungleEntity>> {
  const list = map.get(EntityTypeId.Jungle) || immutableEmptyArray
  return list as Array<EntityGraphNode<JungleEntity>>
}

export function getLakeEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<LakeEntity>> {
  const list = map.get(EntityTypeId.Lake) || immutableEmptyArray
  return list as Array<EntityGraphNode<LakeEntity>>
}

export function getLightReconEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<LightReconEntity>> {
  const list = map.get(EntityTypeId.LightRecon) || immutableEmptyArray
  return list as Array<EntityGraphNode<LightReconEntity>>
}

export function getLightTankEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<LightTankEntity>> {
  const list = map.get(EntityTypeId.LightTank) || immutableEmptyArray
  return list as Array<EntityGraphNode<LightTankEntity>>
}

export function getMarshEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<MarshEntity>> {
  const list = map.get(EntityTypeId.Marsh) || immutableEmptyArray
  return list as Array<EntityGraphNode<MarshEntity>>
}

export function getMediumArtillaryEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<MediumArtillaryEntity>> {
  const list = map.get(EntityTypeId.MediumArtillary) || immutableEmptyArray
  return list as Array<EntityGraphNode<MediumArtillaryEntity>>
}

export function getMediumCopterEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<MediumCopterEntity>> {
  const list = map.get(EntityTypeId.MediumCopter) || immutableEmptyArray
  return list as Array<EntityGraphNode<MediumCopterEntity>>
}

export function getMediumGunAntiAirEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<MediumGunAntiAirEntity>> {
  const list = map.get(EntityTypeId.MediumGunAntiAir) || immutableEmptyArray
  return list as Array<EntityGraphNode<MediumGunAntiAirEntity>>
}

export function getMediumMissileAntiAirEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<MediumMissileAntiAirEntity>> {
  const list = map.get(EntityTypeId.MediumMissileAntiAir) || immutableEmptyArray
  return list as Array<EntityGraphNode<MediumMissileAntiAirEntity>>
}

export function getMediumRocketsEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<MediumRocketsEntity>> {
  const list = map.get(EntityTypeId.MediumRockets) || immutableEmptyArray
  return list as Array<EntityGraphNode<MediumRocketsEntity>>
}

export function getMediumTankEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<MediumTankEntity>> {
  const list = map.get(EntityTypeId.MediumTank) || immutableEmptyArray
  return list as Array<EntityGraphNode<MediumTankEntity>>
}

export function getMountainEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<MountainEntity>> {
  const list = map.get(EntityTypeId.Mountain) || immutableEmptyArray
  return list as Array<EntityGraphNode<MountainEntity>>
}

export function getPlainEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<PlainEntity>> {
  const list = map.get(EntityTypeId.Plain) || immutableEmptyArray
  return list as Array<EntityGraphNode<PlainEntity>>
}

export function getRiverEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<RiverEntity>> {
  const list = map.get(EntityTypeId.River) || immutableEmptyArray
  return list as Array<EntityGraphNode<RiverEntity>>
}

export function getRoadEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<RoadEntity>> {
  const list = map.get(EntityTypeId.Road) || immutableEmptyArray
  return list as Array<EntityGraphNode<RoadEntity>>
}

export function getSeaEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<SeaEntity>> {
  const list = map.get(EntityTypeId.Sea) || immutableEmptyArray
  return list as Array<EntityGraphNode<SeaEntity>>
}

export function getShoalEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<ShoalEntity>> {
  const list = map.get(EntityTypeId.Shoal) || immutableEmptyArray
  return list as Array<EntityGraphNode<ShoalEntity>>
}

export function getSnowEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<SnowEntity>> {
  const list = map.get(EntityTypeId.Snow) || immutableEmptyArray
  return list as Array<EntityGraphNode<SnowEntity>>
}

export function getSwampEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<SwampEntity>> {
  const list = map.get(EntityTypeId.Swamp) || immutableEmptyArray
  return list as Array<EntityGraphNode<SwampEntity>>
}

export function getTransportCopterEntsFromMap (map: Map<EntityTypeId, Array<EntityGraphNode<Entity>>>): Array<EntityGraphNode<TransportCopterEntity>> {
  const list = map.get(EntityTypeId.TransportCopter) || immutableEmptyArray
  return list as Array<EntityGraphNode<TransportCopterEntity>>
}


export default entityTypeMetaList